import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { apiRequest } from "@data/redux/actions/api"
import { inscriptionFunnelService } from "../services/inscriptionFunnelService"

/**
 * Le catalogue en store s'il a été chargé pour cette classe, `null` sinon :
 * un lead de 3ème ouvert après un lead de 2nde, ou une classe changée en
 * route, ne doit pas recevoir la liste de l'autre classe.
 */
export const subjectsForClass = (inscriptionFunnel, studentClass) =>
    studentClass && inscriptionFunnel?.subjectsClass === studentClass
        ? inscriptionFunnel.subjects
        : null

/**
 * Les matières choisies que le catalogue propose. Un catalogue absent ou vide
 * ne dit rien des matières de la classe : la formule reste telle quelle plutôt
 * que d'être vidée.
 */
export const subjectsOfferedBy = (subjectIds, catalogue) => {
    if (!catalogue?.length) return subjectIds
    const offered = new Set(catalogue.map((s) => String(s.id)))
    return subjectIds.filter((id) => offered.has(String(id)))
}

/** Le catalogue matières de la classe du parcours, chargé s'il manque. */
export const useInscriptionSubjects = (studentClass) => {
    const dispatch = useDispatch()
    const subjects = useSelector((s) =>
        subjectsForClass(s.data?.inscriptionFunnel, studentClass)
    )
    const missing = !!studentClass && !subjects

    useEffect(() => {
        if (missing) {
            dispatch(
                apiRequest(
                    inscriptionFunnelService.getInscriptionSubjects,
                    { studentClass },
                    {}
                )
            )
        }
    }, [dispatch, studentClass, missing])

    return subjects
}
